import { render, staticRenderFns } from "./treeduoxuan.vue?vue&type=template&id=c3569ece"
import script from "./treeduoxuan.vue?vue&type=script&lang=js"
export * from "./treeduoxuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports